module.exports = __webpack_public_path__ + "img/news1_icon.04c03206.png";